<template>
  <div>
    <vs-row>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-sm="12"
        vs-xs="12"
        class="mb-5"
      >
        <VueSignaturePad
          style="width: 750px; height: 350px; border; border-style: solid; border-color: #EEEEEE"
          id="signature"
          width="100"
          height="100%"
          ref="signaturePad"
          :options="{
            onBegin: () => {
              $refs.signaturePad.resizeCanvas();
            },
          }"
        /> 
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-sm="12"
        vs-xs="12"
        class="mb-5"
      >
        <div class="flex">
          ลงชื่อ
          <vs-divider style="width: 350px" />

          <vs-button
            size="small"
            icon-pack="feather"
            icon="icon-refresh-cw"
            @click="undo()"
            class="ml-5"
          >
            ล้าง
          </vs-button>
        </div>
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-sm="12"
        vs-xs="12"
        class="mb-5"
      >
        <span class="text-danger text-sm" v-show="!isSignaturePad">
          กรุณาลงชื่อสำหรับใช้ในการยืนยัน
        </span>
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-sm="12"
        vs-xs="12"
        class="mb-5"
      >
        <div>
          <vs-button
            type="filled"
            @click.prevent="submitSiganture"
            class="mt-5 mr-5"
            >ยืนยันการลงชื่อ</vs-button
          >
          <vs-button
            color="danger"
            type="border"
            @click="() => this.$emit('onClosedSignature', false)"
            >ย้อนกลับ</vs-button
          >
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import VueSignaturePad from "vue-signature-pad";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  name: "RegistrationPopup",
  props: {
    passValue: Object,
  },
  components: {
    VueSignaturePad,
  },
  data() {
    return {
      signaturePopup: false,
      isSignaturePad: false,
      companySealImage: null,
    };
  },
  mounted() {},
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
      this.isSignaturePad = false;
    },
    convertDataUrlToBlob(dataUrl) {
      const arr = dataUrl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new Blob([u8arr], { type: mime });
    },
    submitSiganture() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      const signatureFile =
        !isEmpty &&
        new File([this.convertDataUrlToBlob(data)], "signature.png", {
          type: "image/png",
        });
      this.isSignaturePad = !isEmpty;

      if (isEmpty) {
        Swal.fire({
          target: document.getElementById("popup-signature"),
          icon: "warning",
          title: "เกิดข้อผิดพลาด",
          text: "กรุณาลงชื่อผู้ใช้งาน",
          showConfirmButton: false,
        });
      } else {
        let data = {
          id: this.passValue.id, // ไอดีของแต่ละงาน เช่น registrationId , installationId
          name: this.passValue.name,
          userId: localStorage.getItem("accessUserId"),
          signature: signatureFile,
        };
        console.log("this is data ===> ", data);
        this.$store.dispatch("users/validateSignatureUser", data).then(() => {
          const error = this.$store.state.users.error;
          if (error) {
            Swal.fire({
              target: document.getElementById("popup-signature"),
              icon: "error",
              title: "ข้อมูลไม่ถูกต้อง",
              text: "กรุณาตรวจสอบข้อมูลอีกครั้ง",
              showConfirmButton: false,
              timer: 2500,
            });
          } else {
            Swal.fire({
              target: document.getElementById("popup-signature"),
              icon: "success",
              title: "สำเร็จ",
              text: "บันทึกลายเซนต์เรียบร้อยแล้ว",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              if (this.passValue.name == "ยืนยันการลงทะเบียนเรือ") {
                if (this.passValue.type == "registration_user") {
                  const fileName = this.$store.state.users.signatureName;
                  const data = { ...this.passValue.data, fileName };
                  this.$store
                    .dispatch("vessels/setChangeStatus", data)
                    .then(() => {
                      location.reload();
                    });
                } else {
                  if (this.passValue.data.toggleInput) {
                    const fileName = this.$store.state.users.signatureName;
                    const data = { ...this.passValue.data, fileName };
                    this.$store.dispatch("vessels/createRegistration", data);
                  } else {
                    if (this.passValue.data.user.idCardImageFile) {
                      this.$store
                        .dispatch(
                          "users/setInsertUser",
                          this.passValue.data.user
                        )
                        .finally(() => {
                          if (this.$store.state.users.status == 201) {
                            const fileName =
                              this.$store.state.users.signatureName;
                            const data = { ...this.passValue.data, fileName };
                            console.log("this is data ===<<<<", data);
                            this.$store.dispatch(
                              "vessels/createRegistration",
                              data
                            );
                          }
                        });
                    } else {
                      this.$store
                        .dispatch(
                          "users/setInsertUserJuristic",
                          this.passValue.data.user
                        )
                        .finally(() => {
                          if (this.$store.state.users.status == 201) {
                            const fileName =
                              this.$store.state.users.signatureName;
                            const data = { ...this.passValue.data, fileName };
                            console.log("this is data ===<<<<", data);
                            this.$store.dispatch(
                              "vessels/createRegistration",
                              data
                            );
                          }
                        });
                    }
                  }
                }
              } else if (this.passValue.name == "ยืนยันการติดตั้งอุปกรณ์") {
                if (this.passValue.type == "install_user") {
                  const fileName = this.$store.state.users.signatureName;
                  const data = { ...this.passValue.data, fileName };
                  this.$store
                    .dispatch("vessels/setChangeStatus", data)
                    .then(() => {
                      location.reload();
                    });
                } else {
                  const fileName = this.$store.state.users.signatureName;
                  // const data = {...this.passValue.data, fileName}

                  const documents = this.passValue.data.documents;
                  const data = { ...this.passValue.data.data, fileName };

                  console.log("this is data", this.passValue.data);
                  this.$store
                    .dispatch("accessories/installAccessories", {
                      data,
                      documents,
                    })
                    .then(() => {
                      location.reload();
                    });
                }
              }
              // location.reload();
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
